import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'
import { Spinner, Row, Col, Button, Image } from 'react-bootstrap'
import api from '../../../services/api'
import { errorApi } from '../../../utils/errorApi'
import VehicleHistoricalModal from './VehicleHistoricalModal'

import GaugeWhite from '../../../../src/assets/VehicleInfo/alert-icons/GaugeWhite.svg'
import GasPump from '../../../../src/assets/VehicleInfo/alert-icons/GasPump.svg'
import Truck from '../../../../src/assets/VehicleInfo/alert-icons/Truck.svg'
import Warning from '../../../assets/VehicleInfo/alert-icons/Warning.svg'
import Engine from '../../../assets/VehicleInfo/alert-icons/Engine.svg'
import Package from '../../../assets/VehicleInfo/alert-icons/Package.svg'
import Flag from '../../../assets/VehicleInfo/alert-icons/Flag.svg'
import HandPalm from '../../../assets/VehicleInfo/alert-icons/HandPalm.svg'
import XCircle from '../../../assets/VehicleInfo/alert-icons/XCircle.svg'
import StopCircle from '../../../assets/VehicleInfo/alert-icons/StopCircle.svg'
import Swap from '../../../assets/VehicleInfo/alert-icons/Swap.svg'
import ArrowRight from '../../../assets/VehicleInfo/alert-icons/ArrowRight.svg'

import { formatDate } from '../../../utils/format'

import styles from './style.module.css'
import { useLoading } from '../../../hooks/LoadingContext'

function VehicleHistorical({ vehicleId, interval = '', role }) {
  const { isLoading, setIsLoading } = useLoading()
  const [reportsInfo, setReportsInfo] = useState([])

  const reportIconsMap = {
    vehicle_delivered: Flag,
    registered_refuelling: GasPump,
    registered_maintance: Engine,
    on_way_to_delivery: Truck,
    request_delivered: Package,
    speeding: GaugeWhite,
    suspicious_activity: Warning,
    traffic_violation: HandPalm,
    request_canceled: XCircle,
    delivery_interrupted: StopCircle,
    request_transfered: Swap,
    on_way_to_internal_transfer: ArrowRight,
  }

  const [showHistoricalModal, setShowHistoricalModal] = useState(false)

  const handleCloseHistoricalModal = () => setShowHistoricalModal(false)
  const handleShowHistoricalModal = () => setShowHistoricalModal(true)

  const loadData = useCallback(
    async (limit = 10, offset = 0) => {
      try {
        let apiUrl = `/${role}/vehicles/${vehicleId}/deliveries/reports?limit=${limit}&offset=${offset}`
        setIsLoading(true)
        if (interval) apiUrl += `&interval=${interval}`
        const { data } = await api.get(apiUrl)

        if (!data.length && offset !== 0)
          toast.info('Não há mais histórico disponível para o veículo no intervalo especificado.')
        else setReportsInfo((reports) => [...reports, ...data])
      } catch (err) {
        toast.error(
          errorApi(err, 'Falha ao buscar o histórico do veículo. Tente novamente mais tarde.'),
        )
      }
      setIsLoading(false)
    },
    [vehicleId, interval, role, setIsLoading],
  )

  useEffect(() => {
    if (vehicleId) loadData()
  }, [vehicleId, loadData])

  return (
    <Row
      className={`${styles.historicalContainer} border d-flex flex-column justify-content-center align-items-start`}
    >
      {!reportsInfo.length ? (
        <span className={`${styles.infoBadge} text-center`}>Nenhum histórico encontrado</span>
      ) : (
        <div>
          {isLoading ? (
            <Spinner
              animation="border"
              size="sm"
              style={{
                color: '#fff',
                marginRight: 10,
              }}
            />
          ) : (
            <div style={{ marginLeft: 20, marginTop: 20 }}>
              {reportsInfo?.slice(0, 6).map((report, index) => (
                <div key={index}>
                  <Row>
                    <Col className="col-2 text-center">
                      <Image
                        className={styles.historicIcon}
                        width={50}
                        src={reportIconsMap[report.type]}
                      />
                    </Col>
                    <Col className="col-10 d-flex flex-column align-items-start justify-content-center">
                      <span style={{ fontSize: 12 }}>{formatDate(report.created_at)}</span>
                      <span style={{ fontSize: 18, fontWeight: 'bold' }}>{report.title}</span>
                    </Col>
                  </Row>
                  <Row>
                    {index !== reportsInfo.length - 1 && (
                      <Col className="col-2 d-flex justify-content-center">
                        <p
                          style={{
                            width: 2,
                            height: '100%',
                            backgroundColor: '#C3C3C3',
                          }}
                        ></p>
                      </Col>
                    )}
                  </Row>
                </div>
              ))}
              <Col className="col-12 mt-3 mb-3">
                <Button
                  className={styles.loaddMoreBtn}
                  //disabled={}
                  onClick={handleShowHistoricalModal}
                >
                  Ver histórico completo
                </Button>
              </Col>
            </div>
          )}
          {showHistoricalModal && (
            <VehicleHistoricalModal
              show={showHistoricalModal}
              close={handleCloseHistoricalModal}
              loadMoreAction={loadData}
              reportsData={reportsInfo}
            ></VehicleHistoricalModal>
          )}
        </div>
      )}
    </Row>
  )
}

export default VehicleHistorical
